module.exports = __webpack_public_path__ + "img/toilet-paper-slash.3521c230.svg";